import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import Footer from "../layouts/LearnerNav/Footer";
import SideNavNew from "../layouts/LearnerNav/SideNavNew";

import SideNavLMS from "../layouts/LearnerNav/SideNavLMS";

import { MagicLogin } from "../redux/actions/UserAction";

const user = JSON.parse(localStorage.getItem("USER"));

const LMS = ({ component: Component, ...rest }) => {
  var url_string = window.location.href;
  var params = new URL(url_string);
  var userId = params.searchParams.get("id");
  const accessToken = localStorage.getItem("TOKEN");

  useEffect(() => {
    if (!accessToken && userId) {
      var data = {
        userId: userId,
        kid: false,
      };
      const onSuccess = (res) => {
        localStorage.setItem("LOGIN", JSON.stringify("true"));
        localStorage.setItem("ROLE", JSON.stringify("Learner"));
        localStorage.setItem("USER", JSON.stringify(res.data.learner));
        localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
        localStorage.setItem("IS_LOGOUT", true);
        window.location.replace(window.location.href.split("?")[0]);
      };
      const onError = () => {
        window.location.replace(window.location.origin + "/login")
      };
      MagicLogin(data, onSuccess, onError);
    }
  }, [userId]);


  if (!accessToken && userId) {
    return (
      <div
        className="d-flex  align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <div className="row">
          <div className="lds-circle">
            <div></div>
          </div>
          <p>Loading...</p>
        </div>
      </div>
    );
  } else {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (user) {
            return (

              <SideNavLMS>
                <Component {...props} />

              </SideNavLMS>

            );
          } else {
            return (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: props.location },
                }}
              />
            );
          }
        }}
      />
    );
  }
};

export default LMS;
